import { get, unescape } from 'lodash';
import { createSelector } from 'reselect';

const allDomainGroupsIdsSelector = state => get( state, 'domainGroups.allIds', [] );
export const domainGroupsByIdSelector = state => get( state, 'domainGroups.byId', {} );
export const domainGroupsIsLoading = state => get( state, 'domainGroups.isLoading', false );
export const domainGroupsIsUpdating = state => get( state, 'domainGroups.isUpdating', false );
export const domainGroupFormStateSelector = state => get( state, 'domainGroups.formState', {} );

export const domainGroupsSelector = createSelector(
    allDomainGroupsIdsSelector,
    domainGroupsByIdSelector,
    ( domainGroupIds, domainGroupMap ) => domainGroupIds.map( id =>
        ( { ...domainGroupMap[id], name: unescape( domainGroupMap[id].name ) } )
    )
);
